/* eslint-disable */
import React, { useState, useEffect } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Stack, Card, TextField, Container, Button, FormControlLabel,
    Switch, Chip, IconButton
} from '@material-ui/core';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Service from '../Service';
import EditIcon from '@material-ui/icons/Edit';

export const AddDirectSupplierComponent = ({ openOne, handleCloseOne, groupID, operationEntityID }) => {
    const [tableData, setTableData] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [supplierData, setSupplierData] = useState({
        directSupplierName: '',
        nic: '',
        brNumber: '',
        phoneNumber: '',
        isActive: true
    });

    useEffect(() => {
        trackPromise(GetDirectSupplierDetails());
        clearAll();
    }, [openOne]);

    const viewSpecialOrderSearchSchema = Yup.object().shape({
        directSupplierName: Yup.string()
            .required('Supplier Name required')
            .matches(/^[a-zA-Z\.][a-zA-Z\s\.]*$/, "Only alphabets are allowed for this field"),
        nic: Yup.string().required('NIC required').matches(/^(\d{9}[vVxX]|\d{12})$/, 'Entered NIC not valid'),
        brNumber: Yup.string().nullable(true),
        phoneNumber: Yup.string().nullable(true),
    });

    const formik = useFormik({
        initialValues: {
            directSupplierID: 0,
            directSupplierName: supplierData.directSupplierName,
            nic: supplierData.nic,
            brNumber: supplierData.brNumber,
            phoneNumber: supplierData.phoneNumber,
            isActive: supplierData.isActive
        },
        validationSchema: viewSpecialOrderSearchSchema,
        onSubmit: (values) => {
            trackPromise(addEditDirectSupplier(values))
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    async function GetDirectSupplierDetails() {
        var res = await Service.GetDirectSupplierDetails(operationEntityID);
        setTableData(res)
    }

    async function addEditDirectSupplier(values) {
        if (isUpdate == false) {
            var res = await Service.AddDirectSupplier(values, groupID, operationEntityID)
            if (res.statusCode === "Success") {
                toast.success(res.message);
                clearAll();
            } else {
                toast.error(res.message);
            }
            trackPromise(GetDirectSupplierDetails());
        }
        else {
            var res = await Service.UpdateDirectSupplierDetails(values)
            if (res.statusCode === "Success") {
                toast.success(res.message);
                setIsUpdate(false)
                clearAll();
            } else {
                toast.error(res.message);
            }
            trackPromise(GetDirectSupplierDetails());
        }
    }

    async function clearAll() {
        setValues({
            ...values,
            directSupplierID: 0,
            directSupplierName: '',
            nic: '',
            brNumber: '',
            phoneNumber: '',
            isActive: true
        });
        setIsUpdate(false)
    }

    function handleUpdate(data) {
        setValues({
            ...values,
            directSupplierID: data.directSupplierID,
            directSupplierName: data.supplierName,
            nic: data.nic,
            brNumber: data.brNumber == null ? "" : data.brNumber,
            phoneNumber: data.phoneNumber == 0 ? "" : data.phoneNumber,
            isActive: data.isActive
        });
        setIsUpdate(true)
    }

    return (
        <div>
            <LoadingComponent />
            <Dialog fullWidth={true} open={openOne} maxWidth="lg" aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{"Add Direct Supplier"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Container>
                            <FormikProvider value={formik}>
                                <ToastContainer
                                    position="bottom-right"
                                    pauseOnHover
                                />
                                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                    <Stack spacing={3} style={{ marginTop: '10px' }}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label="Supplier Name *"
                                                variant="outlined"
                                                name='directSupplierName'
                                                value={formik.values.directSupplierName}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('directSupplierName')}
                                                error={Boolean(touched.directSupplierName && errors.directSupplierName)}
                                                helperText={touched.directSupplierName && errors.directSupplierName}
                                            />
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label="NIC *"
                                                variant="outlined"
                                                name='nic'
                                                value={formik.values.nic}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('nic')}
                                                error={Boolean(touched.nic && errors.nic)}
                                                helperText={touched.nic && errors.nic}

                                            />
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label="BR Number"
                                                variant="outlined"
                                                name='brNumber'
                                                value={formik.values.brNumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('brNumber')}
                                                error={Boolean(touched.brNumber && errors.brNumber)}
                                                helperText={touched.brNumber && errors.brNumber}
                                            />
                                            <TextField
                                                fullWidth
                                                id="outlined-basic"
                                                size="small"
                                                label="Phone Number"
                                                variant="outlined"
                                                name='phoneNumber'
                                                value={formik.values.phoneNumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('phoneNumber')}
                                                error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                                                helperText={touched.phoneNumber && errors.phoneNumber}
                                            />
                                        </Stack>
                                        <Stack>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        value={formik.values.isActive}
                                                        checked={formik.values.isActive}
                                                        {...getFieldProps('isActive')}
                                                        onClick={formik.handleChange}
                                                        color='error'
                                                        name="isActive"
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />}
                                                label="Is Active"
                                            />
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={clearAll}
                                            >
                                                Clear
                                            </Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >
                                                {isUpdate == false ? "Add" : "Update"}
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Form>
                            </FormikProvider>
                            <br /><Divider variant="middle" />
                            {tableData.length > 0 ?
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Supplier Name</TableCell>
                                                <TableCell align="left">NIC</TableCell>
                                                <TableCell align="left">Status</TableCell>
                                                <TableCell align="left">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableData.map((row) => (
                                                <TableRow key={row.roleID}>
                                                    <TableCell component="th" scope="row">
                                                        {row.supplierName}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.nic}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="left">
                                                        {isUpdate == false ?
                                                            <IconButton aria-label="delete" onClick={() => handleUpdate(row)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                            : null}
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer> : null}
                        </Container>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseOne} color="secondary">
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}